export enum LOG_LEVEL {
    INFO = 'Info',
    DEBUG = 'Debug',
    WARN = 'Warning',
    ERROR = 'Error',
    NONE = 'None',
}
